<template>
  <div>
    <base-header class="pb-6" type="">
      <div class="row align-items-center py-4">
        <breadcrumbs :header="$t('Audience')"></breadcrumbs>
      </div>
    </base-header>
    <v-wait :for="waitFor">
      <template slot="waiting">
        <div class="container loader">
          <div class="row justify-content-md-center">
            <div class="col-md-auto">
              <spinner></spinner>
            </div>
          </div>
        </div>
      </template>
      <div class="container-fluid mt--6">
        <div class="row">
          <div class="col">
            <div class="card bg-transparent">
              <el-table class="table-responsive"
                        header-row-class-name="thead-light"
                        empty-text="Никто еще не купил/подписался на этот курс"
                        :data="students">

                <el-table-column :label="$t('id')" min-width="70px">
                  <template v-slot="{row}">
                    <nobr>{{ row.id }}</nobr>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('Student info')" min-width="200px" prop="name">
                  <template v-slot="{row}">
                    <div class="media align-items-center">
                        <span class="avatar rounded-circle mr-3">
                            <img :alt="row.name" :src="row.photoUrl">
                        </span>
                        <div class="media-body">
                            <span class="font-weight-600 name mb-0 text-sm">{{ row.name }}</span><br />
                            <span class="font-weight-600 name mb-0 text-sm">{{ row.email }}</span>
                        </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('Lessons progress')" prop="contacts"
                                 min-width="150px">
                  <template v-slot="{row}">
                    {{ getStudentProgressPresentation(row.id) }}
                  </template>
                </el-table-column>
                <el-table-column min-width="100px" :label="$t('Payment status')" prop="status">
                  <template v-slot="{row}">
                    <badge v-if="row.status === 'success'" class="badge-dot mr-4" type="success">
                        <i class="bg-success"></i>
                        <span class="status">{{ $t('success') }}</span>
                    </badge>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('Student actions')" prop="actions"
                                 min-width="150px">
                  <template v-slot="{row}">
                    <base-button
                      size="sm"
                      type="neutral"
                      @click="doReviewStudentTaskAnswers(row.id)"
                      v-if="getStudentAnswersOnReview.length > 0">
                      Проверить задания
                    </base-button>
                     <base-button
                      size="sm"
                      type="neutral"
                      @click="sendMessage(row.id)">
                      Отправить сообщение
                    </base-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </v-wait>

  </div>
</template>

<script>
  import Breadcrumbs from "../../../Layout/Breadcrumbs";
  import {Table, TableColumn, Tooltip} from "element-ui";
  import Spinner from "vue-spinner-component/src/Spinner";
  import {createNamespacedHelpers} from 'vuex';
  const {mapState, mapGetters,  mapActions} = createNamespacedHelpers('course/audience');
  import {_} from 'vue-underscore';

  export default {
    name: "CourseAudience",
    metaInfo() {
      return {
        title: this.$i18n.t('Audience')
      }
    },
    components: {
      Breadcrumbs,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      Spinner
    },
    data() {
      return {
        waitFor: 'audience list fetching'
      }
    },
    created() {
      this.fetchData();
    },
    computed: {
      ...mapGetters({
        students: 'getStudents',
        progress: 'getProgress',
        answers: 'getAnswers'
      }),
      getStudentProgress() {
        return id => {
          return _.filter(this.progress, item => item.userId === id)
        }
      },
      getStudentAnswers() {
        return id => {
          return _.filter(this.answers, item => item.userId === id)
        }
      },
      getStudentProgressPresentation() {
        return id => {
          const progress = this.getStudentProgress(id)
          const done = _.filter(progress, item => item.isDone)
          const inProgress = progress.length - done.length
          return this.$i18n.t('progress.studentPresentation', {done: done.length, inProgress})
        }
      },
      getStudentAnswersOnReview() {
        return id => {
          return _.filter(this.getStudentAnswers(id), item => item.status === 'need_review')
        }
      }
    },
    watch: {
      '$route': 'fetchData'
    },
    methods: {
      ...mapActions({
        loadStudents: 'loadStudents',
        loadStudentsProgress: 'loadStudentsProgress',
        loadStudentsAnswers: 'loadStudentsAnswers',
      }),
      async fetchData() {
        this.$wait.start(this.waitFor);
        await this.loadStudents({urlParams: this.$route.params});
        this.$wait.end(this.waitFor);
        await this.loadStudentsProgress({urlParams: this.$route.params})
        await this.loadStudentsAnswers({urlParams: this.$route.params})
      },
      doReviewStudentTaskAnswers(studentId) {
        this.$router.push({
          name: 'course-audience-student',
          params: {...this.$route.params, studentId}
        })
      },
      async sendMessage(receiver_id) {
        const message = prompt('Напишите текст вашего сообщения')
        await this.$store.dispatch(
          'profile/notification/sendMessage',
          {form: {receiver_id, message}}
          )
      }
    }
  }
</script>

<style scoped>
</style>
